import { useEffect, useRef, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const BASE_URL = process.env.REACT_APP_API_URL || "";

export default function VerifyEmailPage() {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState("loading");
  const called = useRef(false);

  useEffect(() => {
    if (called.current) return;
    called.current = true;

    const token = searchParams.get("token");
    if (!token) { setStatus("invalid"); return; }

    fetch(`${BASE_URL}/user/verify-email?token=${encodeURIComponent(token)}`)
      .then((res) => setStatus(res.ok ? "success" : "invalid"))
      .catch(() => setStatus("error"));
  }, [searchParams]);

  return (
    <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", padding: "2rem" }}>
      <div style={{ textAlign: "center", maxWidth: 400 }}>
        {status === "loading" && <p>{t("verifyEmail.loading")}</p>}

        {status === "success" && (
          <>
            <h2>✓ {t("verifyEmail.successTitle")}</h2>
            <p>{t("verifyEmail.successBody")}</p>
            <Link to="/dashboard">{t("verifyEmail.goToDashboard")}</Link>
          </>
        )}

        {(status === "invalid" || status === "error") && (
          <>
            <h2>{t("verifyEmail.errorTitle")}</h2>
            <p>{t("verifyEmail.errorBody")}</p>
            <Link to="/profile">{t("verifyEmail.goToProfile")}</Link>
          </>
        )}
      </div>
    </div>
  );
}
